import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20abstract%20composition%20with%20overlapping%20magazine%20covers%2C%20camera%20flashes%2C%20paparazzi%20silhouettes%2C%20and%20neon%20social%20media%20icons%20floating%20in%20a%20dark%20atmosphere%2C%20theatrical%20stage%20lighting%20with%20warm%20gold%20and%20deep%20crimson%20accents%2C%20mysterious%20and%20glamorous%20celebrity%20gossip%20aesthetic%2C%20editorial%20high%20contrast%20photography%20style%2C%20cinematic%20depth%2C%204K%20quality%2C%20no%20text%20no%20people%20faces&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料吃瓜"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left lg:pt-0 pt-20">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/15 mb-6">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
                <span className="text-xs md:text-sm text-white/90 font-medium">实时追踪 · 今日网红塌房现场</span>
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight">
                娱乐圈最新爆料
                <br />
                <span className="text-accent-400">一手吃瓜第一线</span>
              </h1>
              <p className="mt-4 md:mt-5 text-sm md:text-base text-white/65 max-w-lg mx-auto lg:mx-0 leading-relaxed">
                每日追踪明星网红黑料、反差大瓜与独家爆料视频。塌房现场实时更新，热门爆料一网打尽，吃瓜人的终极聚集地。
              </p>
              <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 lg:justify-start justify-center">
                <Link
                  to="/category/tahouse"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all whitespace-nowrap"
                >
                  开始吃瓜
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/category/exclusive"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-white/25 hover:border-white/50 text-white font-semibold text-sm rounded-lg transition-all whitespace-nowrap"
                >
                  独家深扒
                  <i className="ri-search-eye-line"></i>
                </Link>
              </div>

              <div className="flex items-center gap-6 mt-8 justify-center lg:justify-start">
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold text-white">12,800+</p>
                  <p className="text-[11px] text-white/50">独家爆料</p>
                </div>
                <div className="w-px h-8 bg-white/15"></div>
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold text-white">15亿+</p>
                  <p className="text-[11px] text-white/50">总阅读量</p>
                </div>
                <div className="w-px h-8 bg-white/15"></div>
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold text-white">500万+</p>
                  <p className="text-[11px] text-white/50">日活吃瓜</p>
                </div>
              </div>
            </div>

            <div className="hidden lg:block flex-1">
              <div className="relative">
                <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border-2 border-white/10">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20composition%20of%20a%20shattered%20spotlight%20and%20fallen%20microphone%20on%20a%20dark%20stage%20floor%2C%20scattered%20newspaper%20clippings%20with%20blurred%20headlines%2C%20dramatic%20overhead%20lighting%20creating%20theatrical%20shadows%2C%20warm%20gold%20and%20deep%20charcoal%20contrast%2C%20cinematic%20editorial%20photography%2C%204K%20quality%2C%20no%20text%20no%20faces&width=800&height=600&seq=hero-side-image&orientation=landscape"
                    alt="塌房现场"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-accent-500 text-white px-4 py-2.5 rounded-lg">
                  <p className="text-xs font-medium">今日头条</p>
                  <p className="text-sm font-bold mt-0.5">张三造假塌房</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <div className="animate-bounce">
          <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}